import * as types from './types';

const INITIAL_STATE = {
  languages: [],
  languageFields: {},
  fetchError: null,
  isFetching: false,
  selectedLanguage: 1,
  success: 0,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.LANGUAGE_GETLANGUAGES:
      return {
        ...state,
        languages: action.payload.data,
      };
    case types.LANGUAGE_GETFIELDS:
      return {
        ...state,
        languageFields: action.payload.data,
      };
    case types.LANGUAGE_FETCHING:
      return {
        ...state,
        isFetching: action.payload,
      };
    case types.LANGUAGE_SETLANGUAGE:
      return {
        ...state,
        selectedLanguage: action.payload,
      };
    case types.LANGUAGE_FETCH_ERROR:
      return {
        ...state,
        fetchError: {
          Title: 'Error',
          Message: 'An error has occurred. Please try again',
        },
      };
    case types.LANGUAGE_SETSUCCESS:
      return {
        ...state,
        success: state.fetchError === null ? 1 : 0,
      };
    case types.LANGUAGE_RESETSUCCESS:
      return {
        ...state,
        success: 0,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/languagesetup/state/reducer.js